import React, { useState } from 'react';

export function CardNumberInputMask({ placeholder, setCardNumber, onCardTypeChange }) {
  const [value, setValue] = useState('');

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    const isAmex = /^3[47]/.test(digits);

    if (onCardTypeChange) onCardTypeChange(isAmex);

    let masked;
    if (isAmex) {
      const d = digits.substr(0, 15);
      masked = d.substr(0, 4);
      if (d.length > 4)  masked += ' ' + d.substr(4, 6);
      if (d.length > 10) masked += ' ' + d.substr(10);
    } else {
      const d = digits.substr(0, 16);
      masked = d.substr(0, 4);
      if (d.length > 4)  masked += ' ' + d.substr(4, 4);
      if (d.length > 8)  masked += ' ' + d.substr(8, 4);
      if (d.length > 12) masked += ' ' + d.substr(12);
    }

    if (setCardNumber) setCardNumber(masked);
    setValue(masked);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      id="number"
      name="number"
      data-iugu="number"
      autoComplete="cc-number"
      style={{
        border: '1px solid #D9D9D9',
        borderRadius: '5px',
        padding: '5px',
        fontSize: '16px',
        background: 'transparent',
        width: '100%',
        height: '40px',
        margin: '10px 0px',
        outline: 'none',
        boxShadow: 'none',
      }}
    />
  );
}
